import { gsap, Back, Expo } from 'gsap'
import { breakpointUp } from '../utils/breakpoints'

let wheel = $('#game-wheel')

if(breakpointUp('sm')) {
  $('#game-wheel').attr('src', wheel.attr('data-desk-src'))
} else {
  $('#game-wheel').attr('src', wheel.attr('data-mob-src'))
}

let canSpin = true
let spins = 0
let wRotation = 360

gsap.set(wheel, { rotation: 360 })

function wheelInitSequence()
{
  let canvasID = 'wheel-results-sequence'
  let canvasHtml = $('#' + canvasID)
  let previewHtml = $('#wheel-results-sequence-preview')
  let imageAmount = 20
  let imageName = 'CSDD'
  let imagesDirectory = canvasHtml.data('image-directory')
  let canvasWidth = parseInt(previewHtml.width())
  let canvasHeight = parseInt(previewHtml.height())


  const sequenceImages = []
  for (let i = 0; i <= imageAmount; i ++) {
    let img = new Image
    img.src = `${imagesDirectory}/${imageName}${`0${i}`.slice(-2)}.jpg`

    sequenceImages.push(img);
  }


  canvasHtml.attr('width', canvasWidth).attr('height', canvasHeight)
  let context = canvasHtml[0].getContext('2d');


  let setImage = function (newIndex) {
    if(sequenceImages[newIndex]) {
      context.drawImage(sequenceImages[newIndex], 0, 0, canvasWidth, canvasHeight);
    }

  }

  let currentImage = 0

  setTimeout(function (e){
    setInterval(function (e){
      setImage(currentImage)
      if(currentImage >= imageAmount) {
        currentImage = 0
      } else {
        currentImage += 1
      }
    }, 50)
  }, 1000)

}


function setupConfetti()
{
  let conffetiBackground = $('#results')
  let conffetiBounds = $('.no-results')
  let bounds = conffetiBounds[0].getBoundingClientRect()


  let min = bounds.left
  let max = bounds.left + bounds.width - 50
  let maxTop = 50;
  let minTop = 5

  let confetti = [
    {
      bg: '#b00b00',
      position: Math.random() * (max - min) + min,
      top: Math.random() * (maxTop - minTop) + minTop,
    }, {
      bg: '#de1e7e',
      position: Math.random() * (max - min) + min,
      top: Math.random() * (maxTop - minTop) + minTop,
    }, {
      bg: '#BADA55',
      position: Math.random() * (max - min) + min,
      top: Math.random() * (maxTop - minTop) + minTop,
    }, {
      bg: '#F0FEAF',
      position: Math.random() * (max - min) + min,
      top: Math.random() * (maxTop - minTop) + minTop,
    }, {
      bg: '#ac1d1c',
      position: Math.random() * (max - min) + min,
      top: Math.random() * (maxTop - minTop) + minTop,
    }, {
      bg: '#facade',
      position: Math.random() * (max - min) + min,
      top: Math.random() * (maxTop - minTop) + minTop,
    }, {
      bg: 'transparent',
      position: Math.random() * (max - min) + min,
      top: Math.random() * (maxTop - minTop) + minTop,
      internal: '😜',
    }, {
      bg: 'transparent',
      position: Math.random() * (max - min) + min,
      top: Math.random() * (maxTop - minTop) + minTop,
      internal: '🌵',
    }, {
      bg: 'transparent',
      position: Math.random() * (max - min) + min,
      top: Math.random() * (maxTop - minTop) + minTop,
      internal: '🤑',
    }, {
      bg: 'transparent',
      position: Math.random() * (max - min) + min,
      top: Math.random() * (maxTop - minTop) + minTop,
      internal: '🐻',
    }, {
      bg: 'transparent',
      position: Math.random() * (max - min) + min,
      top: Math.random() * (maxTop - minTop) + minTop,
      internal: '💰',
    }, {
      bg: 'transparent',
      position: Math.random() * (max - min) + min,
      top: Math.random() * (maxTop - minTop) + minTop,
      internal: '🍍',
    }
  ]

  let confettiContainerHtml = conffetiBackground.append('<div class="confetti-container confetti-container-1"></div><div class="confetti-container confetti-container-2"></div>')
  let confettiContainer1 = $('.confetti-container-1')
  let confettiContainer2 = $('.confetti-container-2')

  confetti.map(function(element) {
    const c = $(`<div class="confetti confetti-1" data-top="${element.top}" style="background:${element.bg};top:-${element.top}vh;left:${element.position}px;">${element.internal || ''}</div>`);
    const c2 = $(`<div class="confetti confetti-2" data-top="${element.top}" style="background:${element.bg};top:-${element.top}vh;left:${element.position}px;">${element.internal || ''}</div>`);
    confettiContainer1.append(c);
    confettiContainer2.append(c2);
  });


  if(spins === 0) {
    wheelInitSequence()
  }


}

function runConfetti(c_class)
{
  gsap.to(c_class,
    {top: '150vh', duration: 4, onComplete: () => {
        $('.confetti-container-1').remove()
      }
    })
}

function showResultsAnimation()
{

  runConfetti('.confetti-container-1')

  setTimeout(function (){
    runConfetti('.confetti-container-2')
  }, 1500)

}

function showResults()
{
  $('#game-view').addClass('has-result')
  gsap.fromTo('.my-result', { opacity:0 }, {duration: 1, opacity: 1, onComplete: showResultsAnimation})
  $('.game-popup .popup-content-container').animate({
    scrollTop : 0
  }, 10);
}

function updateResultsView(prize)
{
  if(prize) {

    $('[data-js-title]').text(prize.title)
    $('[data-js-description]').text(prize.description)

    $('[data-js-share-fb-url]').attr('href', prize.share_fb_url)
    $('[data-js-share-twitter-url]').attr('href', prize.share_twitter_url)

    if(prize.image) {
      $('[data-js-image]').attr('src', prize.image)
    }

    if(prize.share_image) {
      $('[data-js-download]').attr('href', prize.share_image)
      $('[property="og:type"]').attr('content', prize.share_image)
    }

    if(prize.show_price === 1) {
      $('[data-js-show-price]').removeClass('hidden')
      $('[data-js-price]').html(prize.price)
    } else {
      $('[data-js-show-price]').addClass('hidden')
    }

  }

}

let spinRotation = 0
$('body').on('click', '.js-spin-wheel', function (e){
  e.preventDefault()

  if(!canSpin) return

  let button = $(this)
  button.css({ opacity: 0.2, cursor: 'default' }).removeClass('c-btn-shake')
  canSpin = false
  spins += 1

  gsap.set('.my-result', { opacity:0 })
  $('.has-result').removeClass('has-result')

  setupConfetti()

  let random = Math.floor(Math.random() * 800) + 600
  let wheelTimeline = gsap.timeline({ repeat: 0, force3D: false })

  wheelTimeline.to(wheel, 6, { rotation: "+=" + random, ease: Back.easeInOut.config(0.5), onComplete: showResults })
  spinRotation += random

  $.ajax({
    type: 'GET',
    url: localize_script.admin_ajax,
    data: {'action': 'spin_wheel', 'score': spinRotation},
    success: function (results) {

      if (results.success === 1) {
        updateResultsView(results.prize)
      } else {
        console.log('no results')
      }

      setTimeout(function (){
        button.css({ opacity: 1, cursor: 'pointer' }).addClass('c-btn-shake')
        canSpin = true
      }, 9000)

    },
  })

})
